import Flickity from 'flickity';

export default class Callouts {
  constructor() {
    this.$els = document.querySelectorAll('.js-callouts');

    this.$els.forEach(($el) => {
      const activeClass = 'is-active';
      const $tabs = $el.querySelectorAll('.js-callouts-tab');
      const $carousel = $el.querySelector('.js-callouts-carousel');
      const $prevButtons = $el.querySelectorAll('.js-callouts-prev');
      const $nextButtons = $el.querySelectorAll('.js-callouts-next');

      const carousel = new Flickity($carousel, {
        cellAlign: 'left',
        contain: true,
        prevNextButtons: false,
        pageDots: false,
        wrapAround: true,
        imagesLoaded: true,
      });

      carousel.on('select', (index) => {
        $tabs.forEach($tab => $tab.classList.remove(activeClass));
        $tabs[index]?.classList.add(activeClass);
      })

      $prevButtons.forEach(($prevButton) => {
        $prevButton.addEventListener('click', () => {
          carousel.previous();
        });
      });

      $nextButtons.forEach(($nextButton) => {
        $nextButton.addEventListener('click', () => {
          carousel.next();
        });
      });

      $tabs.forEach(($tab, index) => {
        $tab.addEventListener('click', () => {
          carousel.select(index);
        })
      });
    });
  }
}
